export const CARD_GROUP_FORM = {
  cgForm: document.querySelector('#aafp_add-card-group') as HTMLFormElement,
  cgUpdateForm: document.querySelector('#aafp_update-card-group') as HTMLFormElement,
  cgSearch: document.querySelector('#aafp_customer-input') as HTMLInputElement,
  cgSearchButton: document.querySelector('#aafp_customer-find') as HTMLInputElement,
  cgResults: document.querySelector('.aafp_customer-container') as HTMLElement,
  cgSelectedCustContainer: document.querySelector('.aafp_customer-result-container') as HTMLElement,
  cgCustomerID:  document.querySelector('.aafp_form-card-group-customer')  as HTMLElement,
  cgName: document.querySelector('#aafp_form-card-group-name') as HTMLInputElement,
  cgPaymentMethod: document.querySelector('#aafp_dropdown-button-payment') as HTMLElement,
  cgMarginCents: document.querySelector('#aafp_form-card-group-margin') as HTMLInputElement,
  cgHose: document.querySelector('#aafp_dropdown-button-hose') as HTMLSelectElement,
  cgTimeoutOverride: document.querySelector('#aafp_form-card-group-override') as HTMLInputElement,
  cgTerminaltax: document.querySelector('#aafp_form-card-group-tax') as HTMLInputElement,
  cgSubmitButton: document.querySelector('#aafp_new-card-group-submit') as HTMLElement,
}

export const PIN_POOL_FORM = {
  ppForm: document.querySelector('#aafp_pin-pool-form') as HTMLFormElement,
  ppCustomerName:  document.querySelector('#aafp_form-customer-name')  as HTMLInputElement,
  ppCardGroupName: document.querySelector('#aafp_form-card-group-name') as HTMLInputElement,
  ppActive: document.querySelector('#aafp_pin-pool-switch') as HTMLInputElement,
  ppActiveWarning: document.querySelector('.aafp_pin-pool-warning') as HTMLElement,
  ppFieldContainer: document.querySelector('.aafp_pin-pool-container-inner') as HTMLElement,
  ppAddPinRecord: document.querySelector('#aafp_add-pin-number') as HTMLElement,
  ppError: document.querySelector('.error-one') as HTMLElement,
  ppErrorTwo: document.querySelector('.error-one') as HTMLElement,
  ppOptionalFields: document.querySelectorAll<HTMLElement>('.aafp_pin-pool-optional'),
  ppSubmitButton: document.querySelector('#aafp_pin-pool-submit') as HTMLElement,
  ppModal: document.querySelector('#pinModal') as HTMLElement,
  ppExport: document.querySelector('#download-csv-file') as HTMLElement,
}

export const VEHICLE_POOL_FORM = {
  vpForm: document.querySelector('#aafp_vehicle-pin-pool-form') as HTMLFormElement,
  vpCustomerName:  document.querySelector('#aafp_form-customer-name')  as HTMLInputElement,
  vpCardGroupName: document.querySelector('#aafp_form-card-group-name') as HTMLInputElement,
  vpActive: document.querySelector('#aafp_vehicle-pool-switch') as HTMLInputElement,
  vpActiveWarning: document.querySelector('.aafp_vehicle-pool-warning') as HTMLElement,
  vpFieldContainer: document.querySelector('.aafp_vehicle-pool-container-inner') as HTMLElement,
  vpAddPinRecord: document.querySelector('#aafp_add-pin-number') as HTMLElement,
  vpError: document.querySelector('.error-one') as HTMLElement,
  vpErrorTwo: document.querySelector('.error-one') as HTMLElement,
  vpOptionalFields: document.querySelectorAll<HTMLElement>('.aafp_vehicle-pool-optional'),
  vpSubmitButton: document.querySelector('#aafp_vehicle-pool-submit') as HTMLElement,
  vpModal: document.querySelector('#pinModal') as HTMLElement,
  vpExport: document.querySelector('#download-csv-file') as HTMLElement,
}

export const PAYMENT_TYPE_CG = [
  { id: 0, name: 'Pay at Pump' },
  { id: 1, name: 'Invoice'},
];

export const HOSE_TYPE_CG = [
  { id: 0, name: 'Autogas/Cylinder Fill' },
  { id: 1, name: 'Autogas'},
  { id: 2, name: 'Cylinder Fill'}
]